import { createAction } from 'redux-actions';
import {
  EMPLOYEE_LIST_FETCH,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_FAILURE,
  DELETE_EMPLOYEE_FETCH,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAILURE
} from './actionTypes';
import api from '../../services/api';

//<<<---FETCH-LIST-OF-EMPLOYEES--->>>
export const employeeListFetch = createAction(EMPLOYEE_LIST_FETCH);
export const employeeListSuccess = createAction(EMPLOYEE_LIST_SUCCESS);
export const employeeListFailure = createAction(EMPLOYEE_LIST_FAILURE);

export const fetchEmployees = () => async dispatch => {
  dispatch(employeeListFetch());
  try {
    const res = await api.get('employee');
    dispatch(employeeListSuccess(res.data));
  } catch (error) {
    dispatch(employeeListFailure(error));
  }
};

//<<<---DELETE-EMPLOYEE--->>>
export const deleteEmployeeFetch = createAction(DELETE_EMPLOYEE_FETCH);
export const deleteEmployeeSuccess = createAction(DELETE_EMPLOYEE_SUCCESS);
export const deleteEmployeeFailure = createAction(DELETE_EMPLOYEE_FAILURE);

export const deleteEmployee = (id, lang, callback) => async dispatch => {
  dispatch(deleteEmployeeFetch());
  try {
    const res = await api.post(`employee/${id}/${lang}`, undefined, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
    dispatch(deleteEmployeeSuccess(res.data));
    callback();
  } catch (error) {
    dispatch(deleteEmployeeFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/EmployeeList/actions.js